const phone = '11 95022-4263';
const phoneWhatsApp = '5511950224263';

export { phone, phoneWhatsApp };
